import cleanObject from "app/shared-components/util/cleanObject";
import {convertToPlain} from "app/shared-components/utils";
import {defaultOrgCover, defaultOrgLogo} from "app/configs/themesConfig";

const generateAddressSchema = (obj, country) => {
    const hasAddress= obj.address && obj.city && obj.stateProvince && obj.postalCode;

    if (!hasAddress) return null;
    else return {
        "@type": "PostalAddress",
        "addressCountry": country,
        ...(obj.address && { "streetAddress": obj.address }),
        ...(obj.city && { "addressLocality": obj.city }),
        ...(obj.stateProvince && { "addressRegion": obj.stateProvince }),
        ...(obj.postalCode && { "postalCode": obj.postalCode })
    };

};

export default generateAddressSchema;